import { useMemo } from "react";
import { useModelService } from "@shared/services/api/hooks/useModelService";
import { UseQueryResult, useQuery, UseQueryOptions } from "react-query";
import UserBasedRefundProtectionRepository, {
  RefundProtectionMetadataType,
  UserRefundProtectionMetadataQueryParamsSerializer,
} from "../../repositories/UserBasedRefundProtectionRepository";

const useUserBasedRefundProtectionService = () => {
  const repository = useMemo(
    () => new UserBasedRefundProtectionRepository(),
    []
  );

  const { queryKeyManager } = useModelService(repository);

  // used to fetch refund protection metadata for displaying when the user is logged in
  const useGetMetadata = (
    params: UserRefundProtectionMetadataQueryParamsSerializer,
    queryOptions?: Omit<
      UseQueryOptions<
        RefundProtectionMetadataType,
        unknown,
        RefundProtectionMetadataType,
        string[]
      >,
      "queryKey" | "queryFn"
    >
  ): UseQueryResult<RefundProtectionMetadataType> => {
    const queryKey = queryKeyManager.generateKey([
      "metadata",
      JSON.stringify(params),
    ]);

    return useQuery(
      queryKey,
      () => repository.metadata(params, { showToastOnError: false }),
      queryOptions
    );
  };

  return {
    useGetMetadata,
  };
};

export default useUserBasedRefundProtectionService;
